module.exports = __webpack_public_path__ + "images/5453c5ec0c664f75a0a4d451c35ed906-Margaritaville.png";